import {
  BackgroundAnimationOverlay,
  Navbar,
  PageContainer,
  PageProviders,
  PushDrawerContainer,
  StageContainer,
} from "../../components";
import { useTranslate } from "@growtherapy/i18n";
import { useRebrand } from "@growtherapy/sprout-ui";
import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetTelehealthSessionInfo } from "../../hooks";
import { setDefaultTitle } from "../../metadata";
import { Theme } from "../../state";
import { INTRO_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from "../constants";
import { PushDrawerWrapper as PushDrawer } from "../PushDrawer";
import { PageContent } from "./page-content/PageContent";

interface PageProps {
  pageContentComponent: FC;
}

export function Page({
  pageContentComponent: PageContentComponent,
}: PageProps) {
  const t = useTranslate();
  const isRebrand = useRebrand();

  useEffect(() => {
    setDefaultTitle(t);
  }, [t]);

  return (
    <>
      <PageProviders theme={Theme.LIGHT}>
        <PageContainer>
          {!isRebrand && <BackgroundAnimationOverlay autoplay={false} />}
          <div className="relative flex flex-col h-full w-full">
            <Navbar />
            <PushDrawerContainer>
              <StageContainer className="bg-transparent overflow-auto justify-normal">
                <PageContentComponent />
              </StageContainer>
              <PushDrawer
                className="sm:my-2 sm:h-auto"
                id={INTRO_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
              />
            </PushDrawerContainer>
          </div>
        </PageContainer>
      </PageProviders>
    </>
  );
}

export function PageWrapper() {
  const { providerShortId, patientShortId } = useParams();
  useGetTelehealthSessionInfo(providerShortId, patientShortId);

  return <Page pageContentComponent={PageContent} />;
}
